// extracted by mini-css-extract-plugin
export default {"root":"InteractiveImageTag__root--G07Zw","selected":"InteractiveImageTag__selected--_ggor","preview":"InteractiveImageTag__preview--rZ8sb"};